// extracted by mini-css-extract-plugin
export default {"modalHeader":"ErrorModal_modalHeader__6WwNu","modalBody":"ErrorModal_modalBody__Lnz6O","modalFooter":"ErrorModal_modalFooter__1a4Ja","conent":"ErrorModal_conent__8h8w7"};